import { render, staticRenderFns } from "./AutoBatchRenewalUPP.vue?vue&type=template&id=c5776da4&"
import script from "./AutoBatchRenewalUPP.vue?vue&type=script&lang=js&"
export * from "./AutoBatchRenewalUPP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports